// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2mTgY","options":"AnswerScale_options__2rThw","selected":"AnswerScale_selected__HtWlH"};